import {
  StyleSheet,
  ImageBackground,
  Platform,
  TouchableOpacity,
  SafeAreaView,
  useWindowDimensions,
} from "react-native";
import React from "react";
import {
  View,
  ScrollView,
  Text,
  Heading,
  Pressable,
  Box,
  Center,
  VStack,
} from "native-base";
import { StackScreenProps } from "../../types";
import Header from "../../components/Header";
import Card, { CardProps } from "../../components/Card";

const FarmInitiatives = ({
  navigation,
}: StackScreenProps<"FarmInitiatives">) => {
  const { width, height } = useWindowDimensions();
  const images = [
    {
      img: require("../../assets/rice_farm.png"),
      title: "Agro Booster",
      desc: [],
    },
    {
      img: require("../../assets/bike_truck.png"),
      title: "Empowering Africa Youth (EMAY)",
      desc: [],
    },
    {
      img: require("../../assets/big_truck.png"),
      title: "OCP School Lab",
      desc: [],
    },
  ];

  const data: CardProps[] = [
    {
      heading: "Agri Booster",
      subheading: "",
      details: "",
      iconName: "",
      onPress: () => navigation.navigate("AgriBooster"),
      image: require("../../assets/vectors/handshake.png"),
    },
    {
      heading: "Empowering Africa Youth (EMAY)",
      subheading: "",
      details: "",
      iconName: "",
      onPress: () => navigation.navigate("EMAY"),
      image: require("../../assets/vectors/hub.png"),
    },

    {
      heading: "OCP School Lab",
      subheading: "",
      details: "",
      iconName: "",
      onPress: () => navigation.navigate("SchoolLab"),
      image: require("../../assets/vectors/folder.png"),
    },
    {
      heading: "Model Farm",
      subheading: "",
      details: "",
      iconName: "",
      onPress: () => navigation.navigate("ModelFarm"),
      image: require("../../assets/vectors/hub.png"),
    },
  ];
  return (
    <ImageBackground
      source={require("../../assets/background.png")}
      resizeMode="cover"
      style={{ width, height }}
    >
      <View style={styles.overlay}>
        <SafeAreaView style={{ height }}>
          <ScrollView>
            <Header
              parentText="Farmer-Centric Projects"
              headingText=" Farm Initiatives"
              onPress={() => navigation.navigate("FarmerCentricProjects")}
            />

            <ScrollView mt={10}>
              {data.map((item) => (
                <Pressable key={item.heading} mb={7} onPress={item.onPress}>
                  <Card
                    heading={item.heading}
                    subheading={item.subheading}
                    details={item.details}
                    iconName={item.iconName}
                    onPress={item.onPress}
                    borderBottomColor="#333333ac"
                    borderColor="#aaa"
                    bg="#2362adf0"
                    cardShadow={{
                      shadowOpacity: 0.8,
                      shadowOffset: { width: 0, height: 15 },
                      shadowRadius: 12,
                      elevation: 2,
                      shadowColor: "#000000",
                    }}
                    image={item.image}
                  />
                </Pressable>
              ))}
            </ScrollView>
          </ScrollView>
        </SafeAreaView>
      </View>
    </ImageBackground>
  );
};

export default FarmInitiatives;

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "#1263c6a3",
  },
  cardOverlay: {
    ...StyleSheet.absoluteFillObject,
    // backgroundColor: "rgba(0, 0, 0, 0.1)",
    backgroundColor: "rgba(0, 127, 109, 0.5)",
  },
});
